import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdate() {
  return (
    <section className="py-12 md:py-16 bg-background-100" aria-label="最新上映">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新上映
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              每日更新，追剧不等待
            </p>
          </div>
          <Link
            to="/category/dianshiju"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3">
                  <span className="text-[10px] text-primary-300 font-medium">
                    {item.updateInfo}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {item.category} · {item.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}